export function artworkSample(image: { width: number; height: number; data: Uint8ClampedArray }, x: number, y: number, mask?: Uint8Array): string | null {
  x = Math.floor(x); y = Math.floor(y);
  if (x < 0 || y < 0 || x >= image.width || y >= image.height || (mask && !mask[y * image.width + x])) return null;
  const offset = (y * image.width + x) * 4;
  if (!image.data[offset + 3]) return null;
  return '#' + [image.data[offset], image.data[offset + 1], image.data[offset + 2]].map(value => value.toString(16).padStart(2, '0')).join('');
}

/** Composite the same ordered paint alpha over the rendered scene pixel. */
export function visibleColorSample(artwork: { width: number; height: number; data: Uint8ClampedArray }, x: number, y: number, scene: ArrayLike<number> | null, mask?: Uint8Array): string | null {
  x = Math.floor(x); y = Math.floor(y);
  if (x < 0 || y < 0 || x >= artwork.width || y >= artwork.height || (mask && !mask[y * artwork.width + x])) return null;
  const offset = (y * artwork.width + x) * 4, alpha = artwork.data[offset + 3] / 255;
  if (!scene || !scene[3]) return alpha === 1 ? artworkSample(artwork, x, y, mask) : null;
  const backgroundAlpha = scene[3] / 255, resultAlpha = alpha + backgroundAlpha * (1 - alpha);
  if (!resultAlpha) return null;
  return '#' + [0,1,2].map(channel => Math.round((artwork.data[offset + channel] * alpha + scene[channel] * backgroundAlpha * (1 - alpha)) / resultAlpha).toString(16).padStart(2, '0')).join('');
}
